import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/_services';
import { DashboardStore, TransactionsStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-cashier',
  templateUrl: 'cashier.page.html',
  styleUrls: ['cashier.page.scss'],
  providers: [DatePipe]
})

export class CashierPage implements OnInit {
  today = Date.now();
  epochDateTime: any;
  datePickerValue: any;
  todayDate: string;
  pickerDate = this.dashboardStore.getPickerDate();
  currentUser: any;
  cashiersReportsDetails = [];
  bankTransferReport = [];
  ussdReport = [];
  bankTransferTotal: any;
  ussdTotal: any;
  merchant: any;
  total: any;
  gettingReports = false;
  iconReload = 'icon-reload';

  constructor(
    private datePipe: DatePipe,
    private auth: AuthenticationService,
    private dashboardStore: DashboardStore,
    private transactionsStore: TransactionsStore,
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  changeDate(ev: any) {
    const date = ev.detail.value;
    console.log(date);
    this.epochDateTime = new Date (date).getTime();
    this.todayDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.pickerDate = this.datePipe.transform(this.epochDateTime, 'yyyy-MM-dd');

    const dateText = document.getElementById('cashier-date-text');
    const dateTextInner: HTMLElement = dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = new Date (this.epochDateTime).toDateString();
    this.dashboardStore.setPickerDate(this.pickerDate);
    this.cashiersReportsDetails = [];

    this.getCashiersReports();

    if (this.todayDate === this.pickerDate) { dateTextInner.innerText = 'Today'; } else  { return; }
  }

  getCashiersReports() {
    this.gettingReports = true;
    this.iconReload = 'icon-reload';
    this.auth.getCashiersReports(this.pickerDate)
    .subscribe(
      (response: any) => {
        this.gettingReports = false;
        this.iconReload = '';
        console.log(response);
        this.transactionsStore.setCashiersBankTransferReports(response.bankTransfer);
        this.bankTransferReport = this.transactionsStore.getCashiersBankTransferReports();
        this.transactionsStore.setCashiersUssdReports(response.ussdTransfer);
        this.ussdReport = this.transactionsStore.getCashiersUssdReports();
        this.merchant = response.merchantAccount.name;
        // this.computeReports();
        // this.bankTransferReport = [];
        // this.ussdReport = [];
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  computeReports() {
    if (this.bankTransferReport.length === 0) {
      this.bankTransferTotal = 0;
      this.cashiersReportsDetails = [];
    }

    if (this.ussdReport.length === 0) {
      this.ussdTotal = 0;
      this.cashiersReportsDetails = [];
    }
    if ((this.ussdReport.length === 0 && this.bankTransferReport.length !== 0) ||
         this.bankTransferReport.length !== 0  && this.ussdReport.length !== 0) {
      this.bankTransferReport.forEach(item => {
        this.bankTransferTotal = parseFloat(item.total);
        console.log(item.total);

        this.ussdReport.forEach(element => {
          this.ussdTotal = parseFloat(element.total);
          console.log(element.total);
        });
        this.getTotal(item);
      });
    } else if (this.bankTransferReport.length === 0 && this.ussdReport.length !== 0) {
      this.ussdReport.forEach(item => {
        this.ussdTotal = parseFloat(item.total);

        this.bankTransferReport.forEach(element => {
          this.bankTransferTotal = parseFloat(element.total);
        });
        this.getTotal(item);
      });
    }
    this.transactionsStore.setCashiersReports(this.cashiersReportsDetails);
    this.cashiersReportsDetails = this.transactionsStore.getCashiersReports();
  }

  getTotal(item: any) {
    this.total =  this.bankTransferTotal + this.ussdTotal;
    console.log(this.total);
    let finalTotal = { id: item.cashierId, name: item.name, total: this.total };
    if (item.name.includes(this.merchant)) {
      finalTotal = { id: item.cashierId, name: item.name + ' - Owner', total: this.total };
    }
    this.cashiersReportsDetails.push(finalTotal);
  }

  refreshCashierReports() {
    this.cashiersReportsDetails = [];
    const rotate = document.getElementById('rotate');
    rotate.classList.add('icon-reload');
    this.gettingReports = true;
    this.auth.getCashiersReports(this.pickerDate)
    .subscribe(
      (response: any) => {
        rotate.classList.remove('icon-reload');
        this.gettingReports = false;
        console.log(response);
        this.bankTransferReport = response.bankTransfer;
        this.ussdReport = response.ussdTransfer;
        this.computeReports();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  ionViewDidEnter() {
    console.log(this.merchant);
  }

  ngOnInit() {
    this.pickerDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.getCashiersReports();
  }

}
